import React, {useCallback, useContext, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {clearSelection} from 'src/components/data-table-selection';
import {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';
import {getMainColumnHeader} from 'src/utils/getMainColumnHeader';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {LocaleContext} from '@pb/kit-context-locale';

import {COLUMNS, HEADERS, SELECTION_KEY, SORTING_ERROR} from '../../constants';
import {
    userConferencesStateActions,
    userConferencesStateSelector,
} from '../../slices/user-conferences-state.slice';
import {
    userConferencesDataSelector,
    userConferencesResultSelector,
} from '../../slices/user-conferences.slice';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export const AccountNameHeader = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(userConferencesStateSelector);

    const {loadingError} = useSelector(userConferencesDataSelector);
    const result = useSelector(userConferencesResultSelector);
    const {locale} = useContext(LocaleContext);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(clearSelection(SELECTION_KEY));
        dispatch(userConferencesStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: AccountSortField.ACCOUNT_NAME,
        }));
    }, [dispatch]);

    useEffect(() => {
        if (loadingError?.message === SORTING_ERROR) {
            sort(SortDirections.ASC);
        }
    }, [loadingError, sort]);

    const caption = useMemo(() => (
        getMainColumnHeader(HEADERS[COLUMNS.ACCOUNT_NAME], locale, result?.totalCount)
    ), [result?.totalCount, locale]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === AccountSortField.ACCOUNT_NAME
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={caption}
            onSort={sort}
        />
    );
};
